module.exports = __webpack_public_path__ + "images/Group 4385c4d844361d57777875fc5d55ce6bf718.svg";